import { Grid } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { RenderInputByTypeMobile } from '../../../../components/formGroupGenerator/RenderInputByTypeMobile';
// import SignaturePad from 'react-signature-canvas';
import toast from 'react-hot-toast';
import { obtenerDataImagen } from '../../../../actions/ImagenAction';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import './stepCondicionesGenerales.scss';

const ID_TIPO_MODULO_DISFAGIA = 7;

export const StepCondicionesGenerales3 = ({
	selectedPrograms,
	edit,
	setDataSubmissionCallback,
	lugarServicioRIEsDomicilio,
	updateFormData,
	paciente,
	fullFormDataRI,
	submitLoading
}) => {
	const [condicionesGenerales, setCondicionesGenerales] = useState(fullFormDataRI?.condicionesGenerales3 ?? {});
	const [combosRI, setCombosRI] = useState();
	const onlyDisfagia = useMemo(() => selectedPrograms.length == 1 && selectedPrograms[0] == ID_TIPO_MODULO_DISFAGIA, [selectedPrograms]);
	const disfagiaNoApto = useMemo(() => !fullFormDataRI?.programaDI1?.videodeglucion && onlyDisfagia, [onlyDisfagia, fullFormDataRI?.programaDI1?.videodeglucion]);

	useEffect(() => {
		if (!!edit) {
			if (disfagiaNoApto) {
				setCondicionesGenerales(prevDatos => ({
					...prevDatos,
					conclusion: false
				}))
			} else {
				setCondicionesGenerales(prevDatos => ({
					...prevDatos,
					conclusion: null
				}))
			}
		}
	}, [disfagiaNoApto]);

	const handleSubmit = () => {
		if (condicionesGenerales.conclusion != null) {
			updateFormData(
				'condicionesGenerales3', condicionesGenerales, validatedinputsGroups.flatMap(x => x.inputs)
			);
		} else
			toast.error('Debe seleccionar una opción en la conclusión');
	}

	const handleChange = (name, value) => {
		setCondicionesGenerales(prevDatos => ({
			...prevDatos,
			[name]: value
		}))
	}

	const getOptionsByName = (fieldName) => {
		const combos = {
			'conclusion': multipleBoolean,
		};
		return combos[fieldName] || [];
	}

	const handleChangeImage = (name, value) => {
		obtenerDataImagen(value).then((image) => {
			handleChange(name,
				{
					contentType: image?.tipo,
					archivo: image?.data,
					extension: image?.extension,
					titulo: image?.nombre
				}
			);
		}).catch();
	};
	const validatedinputsGroups = useMemo(() => {

		const updatedRequired = inputsGroups.map(group => ({
			...group,
			inputs: group.inputs.map(prevInput => {
				const input = {
					...prevInput,
					options: (prevInput.type == 'select' || prevInput.type.includes('multiple')) ? getOptionsByName(prevInput.name) : []
				};

				switch (input.name) {
					case 'higieneInstitucion':
					case 'almacenamientoInstitucion':
					case 'personalInstitucion':
						if (lugarServicioRIEsDomicilio) handleChange(input.name, false);
						return {
							...input,
							required: !lugarServicioRIEsDomicilio
						};

					case 'fechaFirmaConsentimiento':
						if (!condicionesGenerales.consentimientoInformado) {
							handleChange(input.name)
						}
						return {
							...input,
							disabled: !condicionesGenerales.consentimientoInformado,
							required: condicionesGenerales.consentimientoInformado
						};
					case 'conclusion':
						const disfagiaNoApto = !fullFormDataRI?.programaDI1?.videodeglucion && onlyDisfagia;

						return {
							...input,
							disabled: disfagiaNoApto
						};
					case 'consentimientoInput':
						return {
							...input,
							disabled: !condicionesGenerales.consentimientoInformado,
							required: condicionesGenerales.consentimientoInformado
						};
					default:
						return input;
				}
			})
		}))

		return updatedRequired;
	}, [
		selectedPrograms,
		onlyDisfagia,
		condicionesGenerales.consentimientoInformado,
		fullFormDataRI?.programaDI1?.videodeglucion,
		lugarServicioRIEsDomicilio,
		combosRI
	]);

	return (
		<div>
			{validatedinputsGroups.map((group, index) => {
				if (group.subGroupName === 'Condiciones de la institución donde se presta el servicio' && lugarServicioRIEsDomicilio) return null;
				return (
					<div className='step-form-section-container' key={`${group.groupName} ${group.subGroupName} ${index}`}>
						<label className='step-form-section-title'>{group.subGroupName ? group.subGroupName : group.groupName}</label>
						<Grid container>
							{group.inputs.filter(x => !x.hidden).map((input) => {
								return (
									<RenderInputByTypeMobile
										key={`${group.groupName}-${input.name}`}
										grided
										row
										handleDelete={() => {
											handleChange(input.name, null)
										}}
										handleChange={input.type === 'file' ? handleChangeImage : handleChange}
										input={input}
										value={condicionesGenerales[input.name]}
									/>
								)
							})}
						</Grid>
					</div>
				)
			})}
			<Grid sx={{ marginTop: 1.5, marginBottom: 2.5, marginLeft: 2.5, width: '90%' }} size={{ xs: 12 }}>
				<CustomButton
					size='small'
					variant='contained'
					isLoading={submitLoading}
					onClick={handleSubmit}
					disabled={!edit}
					sx={{ width: '100%', padding: '8px' }}
				>
					guardar
				</ CustomButton>
			</Grid>
		</div>
	)
}

export default StepCondicionesGenerales3;

const multipleBoolean = [
	{ value: true, label: 'APTO' },
	{ value: false, label: 'NO APTO' }
];

const inputsGroups = [
	{
		groupName: 'Condiciones de servicio',
		subGroupName: 'Condiciones de la institución donde se presta el servicio',
		inputs: [
			{
				displayName: 'Cumple condiciones de higiene?',
				name: 'higieneInstitucion',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Espacio para almacenar insumos?',
				name: 'almacenamientoInstitucion',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Servicio a cargo del personal de la institución?',
				name: 'personalInstitucion',
				type: 'boolean',
				required: true,
			}
		]
	},
	{
		groupName: 'Condiciones de servicio',
		subGroupName: 'Condiciones para brindar servicio',
		inputs: [
			{
				displayName: 'Evaluación del grupo fliar y entorno psicosocial del paciente es adecuada?',
				name: 'evaluacionFamiliaPsicosocial',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Conclusión',
				name: 'conclusion',
				type: 'multiple_boolean',
				required: true,
				options: []
			}
		]
	},
	{
		groupName: 'Condiciones de servicio',
		subGroupName: 'Consentimiento',
		inputs: [
			{
				displayName: 'Consentimiento Informado',
				name: 'consentimientoInformado',
				type: 'boolean',
				required: true,
			},
			{
				displayName: 'Fecha de firma',
				name: 'fechaFirmaConsentimiento',
				disableFuture: true,
				type: 'date',
				required: true
			},
			{
				displayName: 'Subir consentimiento',
				name: 'consentimientoInput',
				type: 'file',
				required: false,
				validExtensions: ['PDF', 'PNG', 'JPG', 'HEIC', 'JPEG', 'JFIF'],
				maxFileSize: 8,
			}
		]
	},
	// {
	// 	groupName: 'Condiciones de servicio',
	// 	subGroupName: 'Firma paciente / familiar',
	// 	inputs: [
	// 		{
	// 			displayName: 'Firmante',
	// 			name: 'idComboRIValorFirmante',
	// 			comboName: 'Firmante',
	// 			type: 'multiple_boolean',
	// 			required: true,
	// 			options: []
	// 		},
	// 		{
	// 			displayName: 'Otro (Nombre y Apellido)',
	// 			name: 'otroFirmante',
	// 			type: 'string',
	// 			required: false,
	// 		},
	// 		{
	// 			displayName: 'Firma',
	// 			name: 'firmaInput',
	// 			type: '',
	// 			required: true,
	// 			hidden: true
	// 		}
	// 	]
	// }
];





